export { fetchJson, fetchData, StatusError } from './fetchJson';
